export default class TaskService {
  constructor(Authentication, PersonaCollection, sdk, dateFilter) {
    'ngInject';

    Object.assign(this, { Authentication, PersonaCollection, sdk, dateFilter });
    this.getUserFullname = sdk('model-extensions/getUserFullname');
  }

  getCompletedMessage(task, notificationDateFormat) {
    if (!task.completedBy || !task.completedBy.id) {
      return 'This task has been completed';
    }

    const user = this.PersonaCollection.personasDict[task.completedBy.id] || {};
    const fullname =
      user.fullname ||
      this.getUserFullname(this.Authentication.user.settings.showLastNameFirst, task.completedBy);
    const completedDate = this.dateFilter(task.completedDate, notificationDateFormat);

    return `${fullname} completed this task - ${completedDate}`;
  }
}
